module.exports = __webpack_public_path__ + "img/x_white.4b22c0e1.svg";